module.exports = __webpack_public_path__ + "img/Logistics.48895adc.png";